import React,{ useEffect} from 'react';
import "../styles/App.scss";
import Settings from './Settings';
import SoundButtonPlayer from './SoundButtonPlayer';

const HANDWRITING_MODE = '/images/icons/toggle-fontoff.png';
const LEXEND_MODE = '/images/icons/toggle-fonton.png';

const DYSLEXIA_FRIENDLY = "Dyslexia Friendly";
const DYSLEXIA_NOTFRIENDLY = "Not Dyslexia Friendly";

function FontToggle({onFontChange,currFont}){
    const imgToUse = currFont==='MyHandwritten' ? HANDWRITING_MODE : LEXEND_MODE;
    const btnName = currFont=== 'MyHandwritten' ? DYSLEXIA_NOTFRIENDLY: DYSLEXIA_FRIENDLY ;

    const toggleFont=()=>{
        const newFont = currFont === 'MyHandwritten' ? 'Lexend' : 'MyHandwritten';

        onFontChange(newFont);
    }

    useEffect(()=>{
        document.body.classList.remove('font-myhandwritten','font-lexend');

        document.body.classList.add(currFont==='MyHandwritten' ? 'font-myhandwritten':'font-lexend');
    },[currFont]); 

    return(
        <div>
            <SoundButtonPlayer onClick={toggleFont}>
                <Settings
                    settingImg={imgToUse}
                    settingName={btnName}
                />
                {/* <p>{btnName}</p> */}
            </SoundButtonPlayer>
        </div>
    );
}
export default FontToggle;